import styled from "styled-components";
import { BarChart } from "@mui/icons-material";
import { Typography, Grid, Button } from "@mui/material";

export const containerStyle = {
  backgroundColor: "#FFD15C",
  padding: "0.2rem 0.6rem",
  borderRadius: "6px",
  display: "inline-block",
  position: "relative",
  textAlign: "center",
};

export const hiddenTextStyle = {
  visibility: "hidden",
  height: "0",
  overflow: "hidden",
  padding: "0.2rem 0.6rem",
};
